module.exports = __webpack_public_path__ + "assets/img/commissions.eec3f619.svg";